import React from 'react';
import { Shape, styled, LazyImage } from '@teko/ds-desktop';
import giftImg from '../../assets/images/gift.es.js';

const ProductGiftItem = (props) => {
  const { gift } = props;
  return /* @__PURE__ */ React.createElement(Shape, {
    width: 40,
    height: 40,
    borderRadius: "m",
    borderWeight: "m",
    borderColor: "divider",
    borderStyle: "solid",
    backgroundColor: "white",
    onClick: (e) => e.preventDefault()
  }, /* @__PURE__ */ React.createElement(StyledLazyImage, {
    src: gift.src,
    customFallbackImage: giftImg,
    height: 38,
    width: 38,
    imageWidth: 76,
    borderRadius: 8,
    alt: gift.alt,
    contain: true,
    aspectRatio: 1,
    draggable: false
  }));
};
var ProductGiftItem$1 = ProductGiftItem;
const StyledLazyImage = styled(LazyImage)`
  & > img {
    border-radius: 0.5rem;
    display: block;
  }
`;

export { ProductGiftItem$1 as default };
